import React, { Fragment } from "react";
import PropTypes from "prop-types";

const Buttons = ({
  isEdit,
  saving,
  completed,
  allowCompleted,
  allowToEdit,
  onToggle,
  onToggleComplete,
  onSave,
  onDuplicate,
  onDelete,
  onPdf,
  inService
}) => (isEdit ? (
  <div>
    <button
      className="btn btn-grey btn-raised btn-long margin-right-five"
      disabled={saving}
      onClick={onToggle}
    >
      CANCEL
    </button>

    <button
      className="btn btn-pink btn-raised btn-long"
      disabled={saving}
      onClick={onSave}
    >
      SAV{saving ? "ING..." : "E"}
    </button>
  </div>
) : (
  <div>
    {allowCompleted ? (
      <button
        className="btn btn-indigo btn-raised margin-right-five"
        disabled={saving}
        onClick={onToggleComplete}
      >
        {completed ? "MARK INCOMPLETE" : "MARK COMPLETE"}
      </button>
    ) : null}

    {allowToEdit ? (
      <button
        className="btn btn-pink btn-raised btn-long margin-right-five"
        onClick={onToggle}
      >
        EDIT
      </button>
    ) : null}
   
    <a
      key="pdf"
      href={`/in_services/${inService.id}.pdf`}
      target="_blank"
      className="btn btn-indigo btn-raised btn-long margin-right-five"
    >
      PDF
    </a>

    <span className="dropdown">
      <button
        type="button"
        className="btn btn-grey btn-raised btn-long dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
          OPTIONS<span className="caret" />
        </button>
        <ul
          className="dropdown-menu"
          aria-labelledby="options"
        >
          <li>
            <a 
                className="pointer-hand"
                onClick={onDuplicate}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    onDuplicate()
                  }
                }}
                >
                  DUPLICATE
              </a>
          </li>
          <li>
            <a 
              className="pointer-hand" 
              onClick={onDelete}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  onDelete()
                }
              }}
              >
                DELETE
             </a>
          </li>
        </ul>
    </span>
  </div>
));

Buttons.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  completed: PropTypes.bool.isRequired,
  allowCompleted: PropTypes.bool.isRequired,
  allowToEdit: PropTypes.bool.isRequired,
  onToggleComplete: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default Buttons;
